<template>
  <ChatbotContainer
    ref="chatbot"
    :product="product"
    :messages="messages"
    :messagesLoading="messagesLoading"
    @re-fetch-data="reFetchData"
  />
</template>

<script>
import ChatbotContainer from '@/components/chatbot/ChatbotContainer.vue';
import { chatbotApi } from '@/apis/chatbot';

export default {
  name: 'AdsContent',
  components: { ChatbotContainer },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      messages: [],
      messagesLoading: false,
    };
  },
  methods: {
    async getProductHistoryChats({ showLoading = false } = {}) {
      if (showLoading) this.messagesLoading = true;
      try {
        const { data } = await chatbotApi.getProductHistoryChats(this.product._id, 'ads_content');
        this.messages = data?.chatHistory || [];
      } catch (error) {
        console.log('error', error);
      } finally {
        if (showLoading) this.messagesLoading = false;
      }
    },
    reFetchData() {
      this.getProductHistoryChats({ showLoading: false });
    },
    shouldBlockNavigation() {
      const chatbot = this.$refs.chatbot;
      return chatbot && typeof chatbot.shouldBlockNavigation === 'function' ? chatbot.shouldBlockNavigation() : false;
    },
    confirmLeaveWhileProcessing() {
      const chatbot = this.$refs.chatbot;
      return chatbot && typeof chatbot.confirmLeaveWhileProcessing === 'function'
        ? chatbot.confirmLeaveWhileProcessing()
        : true;
    },
  },
  mounted() {
    if (this.product._id) {
      this.getProductHistoryChats({ showLoading: true });
    }
  },
};
</script>
